import { useLocalStorage as vueUseLocalStorage } from '@vueuse/core';

export function useLocalStorage(key, defaultValue = null, options = {}) {
  const storage = vueUseLocalStorage(key, defaultValue, {
    deep: true,
    ...options,
  });

  return {
    value: storage,

    get() {
      return storage.value;
    },

    set(value) {
      storage.value = value;
    },

    remove() {
      storage.value = null;
    },

    has() {
      return storage.value !== null && storage.value !== undefined;
    },
  };
}

export function useUsernameStorage() {
  return useLocalStorage('payment_username', '');
}

export function usePaymentStorage() {
  return useLocalStorage('payment_payload', {
    username: '',
    service: { id: '' },
    method: { id: '' },
    step: 0,
  });
}
